var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 30,
    viewBox: "0 0 95 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Node-map-(2-milestone-closed)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-Switch"
  }, /*#__PURE__*/React.createElement("g", {
    id: "youe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0 0.652344L8.33856 22.5409L8.09451 23.1523C7.36234 24.9458 6.7522 24.7828 3.66083 24.7828H1.87109V30.0002H7.07761C10.8198 30.0002 12.8536 28.492 14.3179 24.6605L23.4293 0.652344H16.5144L12.8129 13.4105C12.5689 14.2257 12.5282 14.9594 12.4468 15.6931C12.4062 16.1007 12.3655 16.5491 11.796 16.5491C11.2266 16.5491 11.1452 16.1007 11.1452 15.6931C11.1452 14.9594 11.0638 14.2257 10.8198 13.4105L6.91491 0.652344H0Z",
    fill: "#292D34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M34.8189 0C27.7413 0 23.4297 5.13587 23.4297 11.413C23.4297 17.6902 27.7413 22.8261 34.8189 22.8261C41.8966 22.8261 46.2082 17.6902 46.2082 11.413C46.2082 5.13587 41.8966 0 34.8189 0ZM34.8189 17.2826C31.6055 17.2826 29.9378 14.5924 29.9378 11.413C29.9378 8.2337 31.6055 5.54348 34.8189 5.54348C38.0323 5.54348 39.7001 8.2337 39.7001 11.413C39.7001 14.5924 38.0323 17.2826 34.8189 17.2826Z",
    fill: "#292D34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M55.8886 22.8263C59.5901 22.8263 61.9493 19.8915 63.0069 17.7719C63.1696 17.4458 63.3729 16.9567 63.8611 17.1605C64.3898 17.3643 63.9831 18.1795 63.6577 18.8317C63.3323 19.4839 63.1289 20.1768 63.1289 21.1551V22.1741H69.637V0.652344H63.1289V8.9268C63.1289 13.8996 60.729 17.2828 58.0851 17.2828C55.7665 17.2828 54.6683 15.9377 54.6683 11.0871V0.652344H48.1602V13.6958C48.1602 19.81 51.2515 22.8263 55.8886 22.8263Z",
    fill: "#292D34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M94.3679 10.7609C94.3679 3.34239 89.0394 0 83.5888 0C76.3892 0 72.2402 4.72826 72.2402 11.413C72.2402 17.7717 76.2265 22.8261 83.7108 22.8261C89.7716 22.8261 93.107 19.0761 93.9612 15H87.4937C86.9649 16.5897 85.704 17.6087 83.6702 17.6087C80.9449 17.6087 79.1145 15.7745 78.667 13.0435H94.2459C94.3273 12.4321 94.3679 11.3723 94.3679 10.7609ZM83.7108 5.05435C86.1107 5.05435 87.7378 6.52174 87.9818 9.13043H78.8297C79.3178 6.80707 80.6195 5.05435 83.7108 5.05435Z",
    fill: "#292D34"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.c8862a9a7ecc66d689c7f7759b5e1112.svg";
export { ForwardRef as ReactComponent };